import React, { useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import SideNavBar from './SideNavBar'
// import GPTHelper from './GPTHelper'
import { AuthContext } from './ContextProvider'

function AppWrapper({ children }) {
  const { auth } = useContext(AuthContext)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (
      !auth.authed &&
      !location.pathname === '/' &&
      !location.pathname === '/insights'
    ) {
      navigate('/')
    }
  }, [auth, location])

  return auth.authed && !location.pathname.includes('/insights') ? (
    <div
      className="d-flex position-relative overflow-hidden"
      style={{
        height: '100vh',
        width: '100vw',
      }}
    >
      <Col xs={1}>
        <SideNavBar setting={{}} />
      </Col>
      <Col xs={11} className="d-flex flex-column px-0">
        <Row className="h-96 overflow-hidden position-relative">{children}</Row>
        <div className="small fw-bold text-dai-light py-2 bg-beige">
          Copyright © 2025 Wavenet RD
        </div>
      </Col>
      {/* <GPTHelper setting={{}} /> */}
    </div>
  ) : (
    <div
      className="d-flex position-relative overflow-hidden bg-beige"
      style={{
        height: '100vh',
        width: '100vw',
      }}
    >
      <Col xs={12} className="d-flex flex-column">
        <Row className="flex-fill">{children}</Row>
      </Col>
    </div>
  )
}

AppWrapper.propTypes = {
  children: PropTypes.shape().isRequired,
  //   setting: PropTypes.shape().isRequired,
}

export default AppWrapper
